/**
 * 创建插件形式的loading
*/
function loading(bool) {
    let node = document.getElementById('app-tui-loading-thdlx1');
    if (bool) {
        //判断如果存在一个loading则不创建
        if (node) { return };
        //创建loading
        var dom = document.createElement('div');
        dom.className = 'app-tui-loading app-z-max';
        dom.id = 'app-tui-loading-thdlx1';
        dom.innerHTML =
            `
        <div class="app-tui-loading-box">
            <div class="app-tui-loading-wq app-main-color"></div>
            <div class="app-tui-loading-nq app-assist-color"></div>
        </div>
        `;
        document.body.appendChild(dom);
    } else {
        //判断如果不存在则直接退出
        if (!node) { return };
        node.remove();
    }
}
export { loading }


// WEBPACK FOOTER //
// ./src/components/plugin/loading.js